import { useToast } from "../../../shared/hooks";
import { resetAddressFields } from "../../../shared/utils/utilsAddress";

export function useCepLookup(formRef: any) {
	const toastHandler = useToast();

	const checkCEP = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const cepRaw = event.target.value;
		const cep = cepRaw.replace(/\D/g, "");

		if (cep.length !== 8) {
			resetAddressFields(formRef, cep);
			showError("CEP não encontrado!");
			return;
		}

		try {
			const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
			const data = await response.json();

			if (data.erro) {
				resetAddressFields(formRef, cep);
				showError("CEP não encontrado!");
				return;
			}

			formRef.current?.setFieldValue("address_zipcode", data.cep);
			formRef.current?.setFieldValue("address_street", data.logradouro);
			formRef.current?.setFieldValue("residence_typeo", "");
			formRef.current?.setFieldValue("address_district", data.bairro);
			formRef.current?.setFieldValue("address_city", data.localidade);
			formRef.current?.setFieldValue("address_state", data.uf);
			formRef.current?.setFieldValue("address_ibge", data.ibge);
		} catch (error) {
			showError("Erro ao buscar CEP!");
		}
	};

	const showError = (message: string) => {
		toastHandler.present({
			type: "error",
			position: "top-right",
			messageOrContent: message,
		});
	};

	return { checkCEP };
}
